const AllProjects = [
    {
        id: 1,
        name: 'Memories',
        category: 'Full-Stack',
        technologies: `React.js, Redux, base64, moment.js, Axios, JWT, Material-UI, skeleton-loading, Node.js, Express.js, Mongoose, bcrypt.js, cors`,
        images: {
            img1: 'https://i.ibb.co/ZgRHhMV/m1.png',
            img2: 'https://i.ibb.co/x6JgDjh/m2.png',
            img3: 'https://i.ibb.co/xGy8Fh8/m3.png',
        },
        description: "Through this website, a user can share his memories and also can like and comment on another user’s post. Users can search his/her favourite memories with titles or tags.",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/memories-client',
        liveWebsite: 'https://memories-sh.netlify.app/'
    },
    {
        id: 2,
        name: 'disney-world',
        category: 'Full-Stack',
        technologies: `React, JavaScript(ES6), styled components for front-end; Node.js, Express, Heroku for back-end; Firebase for hoisting and authentication; MongoDB for database. `,
        images: {
            img1: 'https://i.ibb.co/k5WwBZh/disney1.png',
            img2: 'https://i.ibb.co/JtfpCX3/disney2.png',
            img3: 'https://i.ibb.co/zR7shCN/disney3.png',
        },
        description: "A movie website . where user can watch there favourite series ",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/disney-world-client',
        liveWebsite: 'https://disney-clone-d1e27.web.app/'
    },
    {
        id: 3,
        name: 'dress-house24',
        category: 'Full-Stack.',
        technologies: `React, JavaScript(ES6), Bootstrap, Material-UI, Stripe for front-end;  Node.js, Express, Heroku for back-end; Firebase for hoisting and authentication; MongoDB for database.`,
        images: {
            img1: 'https://i.ibb.co/vkYLwYn/dress1.png',
            img2: 'https://i.ibb.co/G5xLtXH/dress2.png',
            img3: 'https://i.ibb.co/2tp7Rxd/dress3.png'
        },
        description: "Full-Stack Service website where user can order available services.Specially secured Admin Panel & User Panel. Only Admin can add another admin, add any service & also manage services.User can add review which showing dynamically",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/dress-house24-client',
        liveWebsite: 'https://dress-house24.web.app/'
    },
    {
        id: 4,
        name: 'Photo-phactory',
        category: 'Full-Stack',
        technologies: `React.js, Material UI ,Stripe, SessionStorage for front-end; Node.js, Express, Heroku for back-end; Firebase for hoisting and authentication; MongoDB for database.`,
        images: {
            img1: 'https://i.ibb.co/2Zrk5SJ/photo1.png',
            img2: 'https://i.ibb.co/sQ5g9kv/photo2.png',
            img3: 'https://i.ibb.co/hBY1JJL/photo3.png',
        },
        description: "A Photographic website where user can add his best photo & also hired another photographer. User can hired photographer but first have to login first. Users can see their ordered history anytime.",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/Photo-Phactory-client',
        liveWebsite: 'https://photo-phactoryy.web.app/'
    },
    {
        id: 5,
        name: 'town-travel-transport',
        category: 'Front-End.',
        technologies: `React.js, Material UI, Google-Map , Firebase authentication & Firebase hoisting etc.`,
        images: {
            img1: 'https://i.ibb.co/zG6F440/travel1.png',
            img2: 'https://i.ibb.co/r6V07Bh/travel2.png',
            img3: 'https://i.ibb.co/NTSR6jz/travel3.png'
        },
        description: "Website of a town transport .User can buy choose his transport and write his destination. Use google map for user benefits",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/town-travel-transport',
        liveWebsite: 'https://town-travel-transport.web.app/'
    },
    {
        id: 6,
        name: 'Music-player',
        category: 'Front-End.',
        technologies: `JavaScript, HTML5, CSS3, Music-library`,
        images: {
            img1: 'https://i.ibb.co/xJzRHLP/music1.png',
            img2: 'https://i.ibb.co/SfHQ8z7/music2.png',
            img3: 'https://i.ibb.co/SfHQ8z7/music2.png'
        },
        description: "A music player which some awesome song include, user can pause , play his song & also can listen the next song by clicking next button.",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/music-player-v-2',
        liveWebsite: 'https://shahinuralambhuiyan.github.io/music-player-v-2/'
    },
    {
        id: 7,
        name: 'doctors-portal',
        category: 'Full-Stack',
        technologies: `React.js, React-bootstrap , SessionStorage for front-end; Node.js, Express, Heroku for back-end; Firebase for hoisting and authentication; MongoDB for database. `,
        images: {
            img1: 'https://i.ibb.co/Stghbm8/doctor1.png',
            img2: 'https://i.ibb.co/ZXdpCHL/doctor2.png',
            img3: 'https://i.ibb.co/FKxZnrh/doctor3.png'
        },
        description: "A full-stack website where user can take appointment & get medical service from doctors-portal ",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/doctors-portal-client',
        liveWebsite: 'https://doctors-portal-usa.web.app/'
    },
    {
        id: 8,
        name: 'Eid-ul-fitr',
        category: 'Single page Website',
        technologies: `HTML5, CSS3, JavaScript, JQuery, Netlify`,
        images: {
            img1: 'https://i.ibb.co/5cfwtzk/eid1.png',
            img2: 'https://i.ibb.co/F60kN4r/eid2.png',
            img3: 'https://i.ibb.co/zSxNF7J/eid3.png'
        },
        description: "A Single page website to wish 'Eid Mubarak' to all people on the internet. Auto playing a beautiful background Music",
        githubRipository: 'https://github.com/ShahinurAlamBhuiyan/eid-ul-fitr',
        liveWebsite: 'https://eid-ul-fitr.netlify.app/'
    }
]

export default AllProjects;